export default {"src":"/_next/static/media/error-qty.06cab676.svg","height":20,"width":16};